const degenerative_lumbar_spine = {
  name: "Degenerative Lumbar Spine",
  meta: {
    links: [
      {
        label: "Degenerative Lumbar Spine",
        url: "https://www.myorthopedicproblem.com/services/degenerative-lumbar-spine"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__2487d329-c5d5-4d9f-8185-6a316001d098",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__98d80130-d616-42ee-b19c-7009d7c87ccb",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__ad6564e4-5125-4d01-827a-8a7615b89b55,A__bd033979-c2c0-4610-9899-e9126060f2a9,A__9f393bcc-5bc8-495d-b620-5841f0bc0d93",
    "Q__c94c9928-fdeb-43ce-b9e2-a47c35c31398": "A__283f6c13-d389-47b2-8de6-4357b26e039b",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__936173dd-20eb-42bd-8619-e86e48651a1a",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__7664ed7b-609a-4519-b4ed-0622d2bccd46",
    "Q__edc2724c-ad38-4f1a-84d8-780a971c4c6e": "A__aa9057df-b817-47d2-9e33-cac88f6d1b13",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__59483b9b-1f8e-47c5-94c3-b285a6d4178a"
  }
}

const herniated_lumbar_disk = {
  name: "Herniated Lumbar Disk",
  meta: {
    links: [
      {
        label: "Herniated Lumbar Disk",
        url: "https://www.myorthopedicproblem.com/services/herniated-lumbar-disk"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__2487d329-c5d5-4d9f-8185-6a316001d098",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__98d80130-d616-42ee-b19c-7009d7c87ccb",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__ad6564e4-5125-4d01-827a-8a7615b89b55,A__bd033979-c2c0-4610-9899-e9126060f2a9,A__9f393bcc-5bc8-495d-b620-5841f0bc0d93",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__0f09de94-cb81-43cb-b3ec-445c9bcd6028",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__7664ed7b-609a-4519-b4ed-0622d2bccd46",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__59483b9b-1f8e-47c5-94c3-b285a6d4178a"
  }
}

const cervical_radiculopathy = {
  name: "Cervical Radiculopathy",
  meta: {
    links: [
      {
        label: "Cervical Radiculopathy",
        url: "https://www.myorthopedicproblem.com/services/cervical-radiculopathy"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__215544a6-3f04-4cac-bc83-ab9a982c37bc",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__86e32724-0e97-456e-b9e6-3e6db8477a3d",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__9f393bcc-5bc8-495d-b620-5841f0bc0d93,A__6e0ec96b-ddb5-4dcc-a5cd-df30fed1a7ef,A__7181fc0e-b9d9-423d-89c6-42aa8f37a309",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__936173dd-20eb-42bd-8619-e86e48651a1a",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__1c165ace-0c64-43b5-8396-dbe9983b890e",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__67a0871f-5923-4948-b70a-ccf5894760fb",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__f4aa60ec-c00d-4081-b1a8-d68745e9caac"
  }
}

// NO ARTICLE
const degenerative_cervical_spine = {
  name: "Degenerative Cervical Spine",
  meta: {
    links: [
      {
        label: "Degenerative Lumbar Spine",
        url: "https://www.myorthopedicproblem.com/services/degenerative-lumbar-spine"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__215544a6-3f04-4cac-bc83-ab9a982c37bc",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__86e32724-0e97-456e-b9e6-3e6db8477a3d",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__9f393bcc-5bc8-495d-b620-5841f0bc0d93,A__6e0ec96b-ddb5-4dcc-a5cd-df30fed1a7ef,A__7181fc0e-b9d9-423d-89c6-42aa8f37a309",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__936173dd-20eb-42bd-8619-e86e48651a1a",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__1c165ace-0c64-43b5-8396-dbe9983b890e",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__f4aa60ec-c00d-4081-b1a8-d68745e9caac"
  }
}

const herniated_cervical_disk = {
  name: "Herniated Cervical Disk",
  meta: {
    links: [
      {
        label: "Herniated Cervical Disk",
        url: "https://www.myorthopedicproblem.com/services/herniated-cervical-disk"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__215544a6-3f04-4cac-bc83-ab9a982c37bc",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__86e32724-0e97-456e-b9e6-3e6db8477a3d",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__ad6564e4-5125-4d01-827a-8a7615b89b55,A__bd033979-c2c0-4610-9899-e9126060f2a9,A__9f393bcc-5bc8-495d-b620-5841f0bc0d93",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__936173dd-20eb-42bd-8619-e86e48651a1a",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__11da67b6-7035-4c7b-9a7c-ced06c82de50",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__1c165ace-0c64-43b5-8396-dbe9983b890e",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__f4aa60ec-c00d-4081-b1a8-d68745e9caac"
  }
}

const sciatica_pinched_nerve = {
  name: "Sciatica (Pinched Nerve)",
  meta: {
    links: [
      {
        label: "Sciatica (Pinched Nerve)",
        url: "https://www.myorthopedicproblem.com/services/sciatica-pinched-nerve"
      }
    ]
  },
  conditions: {
    "Q__2b83a9cd-40f8-429d-9fbb-b7d151d3018b": "A__2487d329-c5d5-4d9f-8185-6a316001d098",
    "Q__43758602-3311-475e-ad90-06157155edb9": "A__98d80130-d616-42ee-b19c-7009d7c87ccb",
    "Q__99cd93db-56ed-4058-86f1-a5684c759283": "A__ad6564e4-5125-4d01-827a-8a7615b89b55,A__bd033979-c2c0-4610-9899-e9126060f2a9,A__9f393bcc-5bc8-495d-b620-5841f0bc0d93",
    "Q__c94c9928-fdeb-43ce-b9e2-a47c35c31398": "A__2de7bbec-9e5c-46d5-a67c-fecf07cf61a0",
    "Q__db9cf140-852b-4dfd-97fb-d48d507791f3": "A__0f09de94-cb81-43cb-b3ec-445c9bcd6028",
    "Q__e2be48f3-8242-41c0-b073-04d9a664b695": "A__826badce-7393-4369-85bd-1c532491cf3a",
    "Q__ea8c3c72-b614-4fc1-9a7a-51f05ad8595b": "A__7664ed7b-609a-4519-b4ed-0622d2bccd46",
    "Q__ef80033b-bfe9-42f9-92a3-9831e10a69e8": "A__2bfac36d-2fe6-4f78-b5e1-d1d29a686f4c",
    "Q__f5a4de4c-3965-477b-899f-58113cac8f66": "A__59483b9b-1f8e-47c5-94c3-b285a6d4178a"
  }
}


module.exports = {
  degenerative_lumbar_spine,
  herniated_lumbar_disk,
  cervical_radiculopathy,
  degenerative_cervical_spine,
  herniated_cervical_disk,
  sciatica_pinched_nerve
}
